import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CustomCart } from '@cart/const';
import { CustomActiveCartService } from '@cart/data-access';
import { CustomHamburgerMenuService } from '@main/categories-menu/feature';
import { SdvorIconComponent } from '@sdvor/shared/ui/v2';
import { RoutingService, UrlModule } from '@spartacus/core';
import { Observable, combineLatest } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'sd-mini-cart',
  templateUrl: './mini-cart.component.html',
  imports: [AsyncPipe, SdvorIconComponent, RouterLink, UrlModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './mini-cart.component.scss',
})
export class MiniCartComponent implements OnInit {
  isActive$: Observable<boolean>;

  quantity$: Observable<number> = this.customActiveCartService.getActive().pipe(
    startWith<CustomCart>({ totalItems: 0 }),
    map((cart: CustomCart) => cart.totalItems || 0),
  );

  constructor(
    private customActiveCartService: CustomActiveCartService,
    private hamburgerMenuService: CustomHamburgerMenuService,
    private routingService: RoutingService,
  ) {}

  ngOnInit(): void {
    this.isActive$ = combineLatest({
      isExpanded: this.hamburgerMenuService.isExpanded,
      isThisPage: this.routingService.getRouterState().pipe(
        map((routinState) => routinState.state.semanticRoute),
        map((semanticRoute) => semanticRoute === 'cart'),
      ),
    }).pipe(map(({ isExpanded, isThisPage }) => !isExpanded && isThisPage));
  }
}
